/* ==========================================================================
   DF Creación — Previsualizador v2
   - 4 vistas (delantera, trasera, manga derecha, manga izquierda) con la foto
     real del color elegido. La trasera es "<foto>_back" y la manga es
     "<foto>_side" (la manga derecha es la misma foto en espejo).
   - Varias imágenes por vista: se mueven arrastrando y se redimensionan
     desde las esquinas.
   - Al finalizar, la prenda gira entre las 4 vistas.
   - Cada imagen, su ajuste y la técnica viajan al pedido como propiedades de
     línea (properties[...]).
   ========================================================================== */
(function () {
  'use strict';
  if (window.__dfcPv2Init) return;
  window.__dfcPv2Init = true;

  var ZONAS = ['delantera', 'trasera', 'manga_derecha', 'manga_izquierda'];
  var ORDEN_GIRO = ['delantera', 'manga_izquierda', 'trasera', 'manga_derecha'];
  var ETIQUETAS = {
    delantera: 'Delantera',
    trasera: 'Trasera',
    manga_derecha: 'Manga derecha',
    manga_izquierda: 'Manga izquierda'
  };
  var TECNICAS = { dtf: 'DTF', sublimacion: 'Sublimación' };

  /* ---------- Quitar fondo (100% en el navegador) ---------- */
  var iaCargada = null;
  function cargarIa() {
    if (!iaCargada) iaCargada = import('https://esm.sh/@imgly/background-removal@1.5.7');
    return iaCargada;
  }
  function quitarFondoColor(url, cb) {
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var maxDim = 1400;
        var esc = Math.min(1, maxDim / Math.max(img.naturalWidth, img.naturalHeight));
        var w = Math.max(1, Math.round(img.naturalWidth * esc));
        var h = Math.max(1, Math.round(img.naturalHeight * esc));
        var c = document.createElement('canvas');
        c.width = w;
        c.height = h;
        var ctx = c.getContext('2d');
        ctx.drawImage(img, 0, 0, w, h);
        var id = ctx.getImageData(0, 0, w, h);
        var d = id.data;
        function ix(x, y) { return (y * w + x) * 4; }
        var esq = [[0, 0], [w - 1, 0], [0, h - 1], [w - 1, h - 1]];
        var br = 0, bg = 0, bb = 0;
        esq.forEach(function (p) {
          var i = ix(p[0], p[1]);
          br += d[i]; bg += d[i + 1]; bb += d[i + 2];
        });
        br /= 4; bg /= 4; bb /= 4;
        var tol = 42;
        var vis = new Uint8Array(w * h);
        var cola = [];
        var x, y;
        for (x = 0; x < w; x++) { cola.push(x, 0, x, h - 1); }
        for (y = 0; y < h; y++) { cola.push(0, y, w - 1, y); }
        while (cola.length) {
          var qy = cola.pop();
          var qx = cola.pop();
          if (qx < 0 || qy < 0 || qx >= w || qy >= h) continue;
          var p = qy * w + qx;
          if (vis[p]) continue;
          vis[p] = 1;
          var i = ix(qx, qy);
          var dr = d[i] - br, dg = d[i + 1] - bg, db = d[i + 2] - bb;
          if (Math.sqrt(dr * dr + dg * dg + db * db) <= tol) {
            d[i + 3] = 0;
            cola.push(qx + 1, qy, qx - 1, qy, qx, qy + 1, qx, qy - 1);
          }
        }
        ctx.putImageData(id, 0, 0);
        c.toBlob(function (blob) { cb(blob); }, 'image/png');
      } catch (err) {
        cb(null);
      }
    };
    img.onerror = function () { cb(null); };
    img.src = url;
  }
  function quitarFondo(url, cb) {
    cargarIa()
      .then(function (mod) { return mod.removeBackground(url); })
      .then(function (blob) { cb(blob); })
      .catch(function () { quitarFondoColor(url, cb); });
  }

  /* ---------- Utilidades ---------- */
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function normalizarUrl(s) {
    if (!s) return s;
    return s.indexOf('//') === 0 ? 'https:' + s : s;
  }
  function conAncho(s) {
    s = normalizarUrl(s);
    if (!s) return s;
    return s + (s.indexOf('?') === -1 ? '?' : '&') + 'width=1200';
  }
  function nombreArchivo(src) {
    var p = String(src || '').split('?')[0];
    p = p.substring(p.lastIndexOf('/') + 1);
    p = p.replace(/\.[a-z0-9]+$/i, '');
    // Shopify añade "_<uuid>" si el nombre ya existía: lo ignoramos
    return p.replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i, '');
  }
  function buscarPorNombre(pool, nombre) {
    for (var i = 0; i < pool.length; i++) {
      if (nombreArchivo(pool[i]) === nombre) return pool[i];
    }
    return null;
  }

  /* ---------- Medidas y precios ---------- */
  function num(v) {
    if (v === null || v === undefined) return NaN;
    return parseFloat(String(v).replace(',', '.'));
  }
  function euros(v) {
    return v.toFixed(2).replace('.', ',') + ' €';
  }
  function cm(v) {
    return (Math.round(v * 10) / 10).toFixed(1).replace('.', ',').replace(',0', '');
  }
  function normTalla(s) {
    return String(s || '').toLowerCase().replace(/años|anos|año|ano/g, '').replace(/[–—]/g, '-').replace(/\s+/g, '').trim();
  }
  // "10x10:2.28, 21x21:4.50" -> [{a:10,b:10,precio:2.28,nombre:'10×10'}]
  function leerTramos(txt) {
    var out = [];
    String(txt || '').split(/[;,\n]+/).forEach(function (p) {
      var m = p.match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*[:=]\s*(\d+(?:[.,]\d+)?)/i);
      if (!m) return;
      var a = num(m[1]), b = num(m[2]);
      out.push({ a: a, b: b, precio: num(m[3]), nombre: cm(a) + '×' + cm(b) });
    });
    out.sort(function (x, y) { return x.a * x.b - y.a * y.b; });
    return out;
  }
  function tramoPara(w, h, tramos) {
    var tol = 0.05;
    for (var i = 0; i < tramos.length; i++) {
      var t = tramos[i];
      if ((w <= t.a + tol && h <= t.b + tol) || (w <= t.b + tol && h <= t.a + tol)) return t;
    }
    return null;
  }

  function init() {
    var root = document.querySelector('[data-dfc-pv2]');
    if (!root) return;

    var stage = root.querySelector('[data-pv2-stage]');
    var baseImg = root.querySelector('[data-pv2-base]');
    var capa = root.querySelector('[data-pv2-capa]');
    var guia = root.querySelector('[data-pv2-guia]');
    var fileInput = root.querySelector('[data-pv2-file]');
    var uploadLabel = root.querySelector('[data-pv2-upload]');
    var uploadTexto = root.querySelector('[data-pv2-upload-texto]');
    var panelItem = root.querySelector('[data-pv2-item-panel]');
    var rango = root.querySelector('[data-pv2-escala]');
    var btnCentrar = root.querySelector('[data-pv2-centrar]');
    var btnEliminar = root.querySelector('[data-pv2-eliminar]');
    var toggleFondoWrap = root.querySelector('[data-pv2-fondo-wrap]');
    var toggleFondo = root.querySelector('[data-pv2-fondo]');
    var estadoFondo = root.querySelector('[data-pv2-fondo-estado]');
    var btnSiguiente = root.querySelector('[data-pv2-siguiente]');
    var avisoTecnica = root.querySelector('[data-dfc-pv-tecnica-aviso]');
    var avisoVacio = root.querySelector('[data-pv2-aviso-vacio]');
    var tabs = root.querySelectorAll('[data-dfc-pv-tab]');
    var botonesTecnica = root.querySelectorAll('[data-dfc-pv-tecnica]');
    var fin = root.querySelector('[data-pv2-final]');
    var cajaMedida = root.querySelector('[data-pv2-medida]');
    var inAncho = root.querySelector('[data-pv2-ancho-cm]');
    var inAlto = root.querySelector('[data-pv2-alto-cm]');
    var avisoMedida = root.querySelector('[data-pv2-medida-aviso]');
    var cajaPrecio = root.querySelector('[data-pv2-precio]');
    var finPrecio = root.querySelector('[data-pv2-fin-precio]');
    if (!stage || !baseImg || !capa || !fileInput) return;

    // Precios (sin IVA) y medidas de la prenda
    var tramosPorTecnica = {
      dtf: leerTramos(root.getAttribute('data-precios-dtf')),
      sublimacion: leerTramos(root.getAttribute('data-precios-sublimacion'))
    };
    var descuentos = String(root.getAttribute('data-descuentos') || '0,30,40,50')
      .split(/[;,\s]+/).map(num).filter(function (n) { return !isNaN(n); });
    if (!descuentos.length) descuentos = [0];
    var textoIva = root.getAttribute('data-texto-iva') || 'IVA no incluido. Precio orientativo.';
    var anchoCuerpoFoto = num(root.getAttribute('data-ancho-cuerpo-foto'));
    var anchosTalla = {};
    try {
      var crudo = JSON.parse(root.getAttribute('data-anchos-talla') || '{}') || {};
      Object.keys(crudo).forEach(function (k) {
        var v = crudo[k];
        var n = typeof v === 'object' && v !== null ? num(v.ancho) : num(v);
        if (!isNaN(n)) anchosTalla[normTalla(k)] = n;
      });
    } catch (e) {}
    var tallaActual = '';
    var precioPrenda = null;

    var zonasDef = {};
    var fijos = {};
    try { zonasDef = JSON.parse(root.getAttribute('data-zonas') || '{}'); } catch (e) {}
    fijos = {
      trasera: root.getAttribute('data-fijo-trasera') || '',
      manga_derecha: root.getAttribute('data-fijo-manga-derecha') || '',
      manga_izquierda: root.getAttribute('data-fijo-manga-izquierda') || ''
    };
    var productUrl = root.getAttribute('data-product-url');
    var autoGiro = root.getAttribute('data-autogiro') !== 'false';
    var textoSubida = uploadTexto ? uploadTexto.textContent : '';
    var textoOtra = root.getAttribute('data-texto-otra') || 'Añadir otra imagen';
    var textoContinuar = root.getAttribute('data-texto-continuar') || 'Continuar';
    var textoFinalizar = root.getAttribute('data-texto-finalizar') || 'Finalizar y ver mi diseño';

    var items = { delantera: [], trasera: [], manga_derecha: [], manga_izquierda: [] };
    var vistas = {
      delantera: { src: baseImg.getAttribute('src') || '', espejo: false },
      trasera: { src: baseImg.getAttribute('src') || '', espejo: false },
      manga_derecha: { src: baseImg.getAttribute('src') || '', espejo: false },
      manga_izquierda: { src: baseImg.getAttribute('src') || '', espejo: false }
    };
    var zonaActiva = 'delantera';
    var sel = null;
    var tecnica = null;
    var contador = 0;

    /* ---------- Fotos por color ---------- */
    function aplicarBase(z) {
      var v = vistas[z] || vistas.delantera;
      if (v.src && baseImg.getAttribute('src') !== v.src) baseImg.setAttribute('src', v.src);
      baseImg.classList.toggle('dfc-pv2-espejo', !!v.espejo);
    }

    function varianteDesdePagina(pj) {
      var picker = document.querySelector('variant-picker[data-template-product-match="true"]') || document.querySelector('variant-picker');
      if (!picker) return null;
      var sel = {};
      picker.querySelectorAll('input[type="radio"]:checked').forEach(function (inp) {
        if (inp.dataset && inp.dataset.optionName) sel[inp.dataset.optionName] = inp.value;
      });
      picker.querySelectorAll('select').forEach(function (s) {
        var o = s.options[s.selectedIndex];
        var n = (o && o.dataset && o.dataset.optionName) || (s.dataset && s.dataset.optionName) || '';
        if (n && o) sel[n] = o.value;
      });
      var nombres = (pj.options || []).map(function (o) { return typeof o === 'string' ? o : (o && o.name) || ''; });
      if (!nombres.length) return null;
      var valores = nombres.map(function (n) { return Object.prototype.hasOwnProperty.call(sel, n) ? sel[n] : null; });
      if (valores.some(function (v) { return v === null; })) return null;
      var variants = pj.variants || [];
      var mejor = null;
      var mejorPts = 0;
      for (var i = 0; i < variants.length; i++) {
        var vo = variants[i].options || [];
        var pts = 0;
        for (var k = 0; k < valores.length; k++) {
          if (vo[k] === valores[k]) pts += /talla|size|tama/i.test(nombres[k]) ? 1 : 10;
        }
        if (pts > mejorPts) { mejor = variants[i]; mejorPts = pts; }
      }
      if (!mejor) return null;
      var copia = {};
      for (var key in mejor) { if (Object.prototype.hasOwnProperty.call(mejor, key)) copia[key] = mejor[key]; }
      copia.options = valores;
      return copia;
    }

    function recalcularVistas(pj, variantId) {
      if (!pj) return;
      var variants = pj.variants || [];
      var variante = null;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(variantId)) { variante = variants[i]; break; }
      }
      // Los productos con más de 250 variantes no vienen enteros en /products/<handle>.js:
      // si la variante no está, se usa lo elegido en la página (color y talla).
      if (!variante) variante = varianteDesdePagina(pj);
      if (!variante) variante = variants[0];
      if (variante) {
        var opciones = pj.options || [];
        var idxTalla = -1;
        opciones.forEach(function (o, k) {
          var n = typeof o === 'string' ? o : (o && o.name);
          if (idxTalla === -1 && /talla|size|tama/i.test(n || '')) idxTalla = k;
        });
        var kAntes = cmPorPct();
        tallaActual = idxTalla !== -1 && variante.options ? variante.options[idxTalla] : '';
        var kAhora = cmPorPct();
        // Al cambiar de talla se conservan los cm elegidos: el diseño se ve más grande o más pequeño.
        if (kAntes && kAhora && kAntes !== kAhora) {
          ZONAS.forEach(function (z) {
            items[z].forEach(function (it) {
              it.w = clamp((it.w * kAntes) / kAhora, 2, 160);
              posicionar(it);
            });
          });
        }
        precioPrenda = typeof variante.price === 'number' ? variante.price / 100 : null;
        actualizarTodo();
      }
      var frente = (variante && variante.featured_image && variante.featured_image.src) || pj.featured_image || '';
      if (!frente) return;
      var pool = [];
      (pj.images || []).forEach(function (s) { pool.push(s); });
      (pj.media || []).forEach(function (m) { if (m && m.src) pool.push(m.src); });
      var nombre = nombreArchivo(frente);
      var atras = buscarPorNombre(pool, nombre + '_back');
      var lado = buscarPorNombre(pool, nombre + '_side');

      vistas.delantera = { src: conAncho(frente), espejo: false };
      vistas.trasera = { src: fijos.trasera || conAncho(atras || frente), espejo: false };
      vistas.manga_izquierda = { src: fijos.manga_izquierda || conAncho(lado || frente), espejo: false };
      if (fijos.manga_derecha) {
        vistas.manga_derecha = { src: fijos.manga_derecha, espejo: false };
      } else {
        vistas.manga_derecha = { src: conAncho(lado || frente), espejo: !!lado };
      }
      ORDEN_GIRO.forEach(function (z) { var im = new Image(); im.src = vistas[z].src; });
      aplicarBase(zonaActiva);
      if (fin && !fin.hidden) pintarVistaFinal(ORDEN_GIRO[giroIdx]);
    }

    var productoJson = null;
    var variantInput = document.querySelector('input[name="id"]');
    var ultimaVariante = variantInput ? variantInput.value : null;
    if (productUrl) {
      fetch(productUrl + '.js')
        .then(function (r) { return r.json(); })
        .then(function (pj) {
          productoJson = pj;
          recalcularVistas(pj, variantInput ? variantInput.value : null);
        })
        .catch(function () {});
      setInterval(function () {
        var actual = variantInput ? variantInput.value : null;
        if (!variantInput) variantInput = document.querySelector('input[name="id"]');
        if (actual && actual !== ultimaVariante) {
          ultimaVariante = actual;
          if (productoJson) recalcularVistas(productoJson, actual);
        }
      }, 400);
    }

    /* ---------- Zona guía ---------- */
    function rectZona(z) {
      var d = zonasDef[z] || {};
      return {
        x: Number(d.x) || 30,
        y: Number(d.y) || 25,
        w: Number(d.w) || 40,
        h: Number(d.h) || 35
      };
    }
    function pintarGuia() {
      if (!guia) return;
      var r = rectZona(zonaActiva);
      guia.style.left = r.x + '%';
      guia.style.top = r.y + '%';
      guia.style.width = r.w + '%';
      guia.style.height = r.h + '%';
    }

    /* ---------- Elementos de imagen ---------- */
    function posicionar(it) {
      var el = it.el;
      if (!el) return;
      el.style.width = it.w + '%';
      el.style.left = it.cx + '%';
      el.style.top = it.cy + '%';
      el.style.aspectRatio = String(it.aspecto);
      pintarCotas(it);
    }

    /* ---------- Cotas (medida real en cm) ---------- */
    function cmPorPct() {
      var ancho = anchosTalla[normTalla(tallaActual)];
      if (!ancho || !anchoCuerpoFoto) return null;
      return ancho / anchoCuerpoFoto;
    }
    function medidaCm(it) {
      var k = cmPorPct();
      if (!k) return null;
      var w = it.w * k;
      return { w: w, h: w / it.aspecto };
    }
    function pintarCotas(it) {
      if (!it.el) return;
      var ch = it.el.querySelector('.dfc-pv2-cota--h b');
      var cv = it.el.querySelector('.dfc-pv2-cota--v b');
      var m = medidaCm(it);
      it.el.classList.toggle('dfc-pv2-item--sin-cotas', !m);
      if (!m || !ch || !cv) return;
      ch.textContent = cm(m.w) + ' cm';
      cv.textContent = cm(m.h) + ' cm';
      var tramos = tramosPorTecnica[tecnica] || [];
      it.el.classList.toggle('dfc-pv2-item--grande', !!(tramos.length && !tramoPara(m.w, m.h, tramos)));
    }
    function pintarMedidaPanel() {
      if (!cajaMedida) return;
      var m = sel ? medidaCm(sel) : null;
      cajaMedida.hidden = !sel;
      if (!sel) return;
      var activo = document.activeElement;
      if (inAncho) {
        inAncho.disabled = !m;
        if (activo !== inAncho) inAncho.value = m ? cm(m.w) : '';
      }
      if (inAlto) {
        inAlto.disabled = !m;
        if (activo !== inAlto) inAlto.value = m ? cm(m.h) : '';
      }
      if (avisoMedida) {
        var txt = '';
        if (!m) {
          txt = 'Elige la talla para ver la medida real del diseño.';
        } else {
          var tramos = tramosPorTecnica[tecnica] || [];
          if (tramos.length && !tramoPara(m.w, m.h, tramos)) {
            var mayor = tramos[tramos.length - 1];
            txt = 'Este diseño mide más de ' + mayor.nombre + ' cm: el precio te lo diremos en el presupuesto.';
          }
        }
        avisoMedida.textContent = txt;
        avisoMedida.hidden = !txt;
      }
    }
    function fijarMedida(valor, eje) {
      var k = cmPorPct();
      var v = num(valor);
      if (!sel || !k || isNaN(v) || v <= 0) return;
      var nuevoW = eje === 'alto' ? (v * sel.aspecto) / k : v / k;
      sel.w = clamp(nuevoW, 2, 160);
      posicionar(sel);
      actualizarTodo();
    }
    if (inAncho) {
      inAncho.addEventListener('input', function () { fijarMedida(inAncho.value, 'ancho'); });
      inAncho.addEventListener('change', function () { fijarMedida(inAncho.value, 'ancho'); inAncho.blur(); pintarMedidaPanel(); });
    }
    if (inAlto) {
      inAlto.addEventListener('input', function () { fijarMedida(inAlto.value, 'alto'); });
      inAlto.addEventListener('change', function () { fijarMedida(inAlto.value, 'alto'); inAlto.blur(); pintarMedidaPanel(); });
    }

    /* ---------- Presupuesto orientativo ---------- */
    function calcularPresupuesto() {
      var tramos = tramosPorTecnica[tecnica] || [];
      var lineas = [];
      var aConsultar = false;
      ZONAS.forEach(function (z) {
        items[z].forEach(function (it, idx) {
          var m = medidaCm(it);
          var t = m && tramos.length ? tramoPara(m.w, m.h, tramos) : null;
          if (!t) aConsultar = true;
          lineas.push({ etiqueta: ETIQUETAS[z] + ' ' + (idx + 1), medida: m, tramo: t, precio: t ? t.precio : null });
        });
      });
      var conPrecio = lineas.filter(function (l) { return l.precio !== null; });
      conPrecio.sort(function (a, b) { return b.precio - a.precio; });
      var total = 0;
      conPrecio.forEach(function (l, i) {
        l.descuento = descuentos[Math.min(i, descuentos.length - 1)] || 0;
        l.final = Math.round(l.precio * (100 - l.descuento)) / 100;
        total += l.final;
      });
      return { lineas: lineas, total: Math.round(total * 100) / 100, aConsultar: aConsultar, sinTarifa: !tramos.length };
    }
    function cantidad() {
      var q = document.querySelector('input[name="quantity"]');
      var n = q ? parseInt(q.value, 10) : 1;
      return n > 0 ? n : 1;
    }
    function pintarPresupuesto() {
      var p = calcularPresupuesto();
      var hay = p.lineas.length > 0 && !!tecnica;
      var html = '';
      var resumen = '';
      if (hay) {
        html += '<p class="dfc-pv2-precio__titulo">Presupuesto orientativo (por prenda)</p><ul class="dfc-pv2-precio__lista">';
        p.lineas.forEach(function (l) {
          var med = l.medida ? cm(l.medida.w) + ' × ' + cm(l.medida.h) + ' cm' : 'sin medida';
          var der;
          if (l.precio === null) {
            der = 'a consultar';
          } else if (l.descuento) {
            der = '<s>' + euros(l.precio) + '</s> −' + l.descuento + '% = ' + euros(l.final);
          } else {
            der = euros(l.final);
          }
          var tr = l.tramo ? ' <small>(hasta ' + l.tramo.nombre + ')</small>' : '';
          html += '<li><span>' + l.etiqueta + ' · ' + med + tr + '</span><span>' + der + '</span></li>';
        });
        html += '</ul>';
        if (p.sinTarifa) {
          html += '<p class="dfc-pv2-precio__linea"><span>Estampación</span><strong>a consultar</strong></p>';
          resumen = 'Estampación a consultar';
        } else {
          html += '<p class="dfc-pv2-precio__linea"><span>Estampación' + (p.aConsultar ? ' (sin contar lo que va a consultar)' : '') + '</span><strong>' + euros(p.total) + '</strong></p>';
          if (precioPrenda !== null) {
            var porPrenda = Math.round((precioPrenda + p.total) * 100) / 100;
            html += '<p class="dfc-pv2-precio__linea"><span>Prenda' + (tallaActual ? ' (' + tallaActual + ')' : '') + '</span><strong>' + euros(precioPrenda) + '</strong></p>';
            html += '<p class="dfc-pv2-precio__linea dfc-pv2-precio__total"><span>Total por prenda</span><strong>' + euros(porPrenda) + '</strong></p>';
            var q = cantidad();
            if (q > 1) html += '<p class="dfc-pv2-precio__linea"><span>× ' + q + ' prendas</span><strong>' + euros(Math.round(porPrenda * q * 100) / 100) + '</strong></p>';
            resumen = 'Total aprox. por prenda: ' + euros(porPrenda);
          } else {
            resumen = 'Estampación aprox.: ' + euros(p.total);
          }
          if (p.aConsultar) resumen += ' + parte a consultar';
        }
        html += '<p class="dfc-pv2-precio__nota">' + textoIva + '</p>';
      }
      if (cajaPrecio) {
        cajaPrecio.innerHTML = html;
        cajaPrecio.hidden = !hay;
      }
      if (finPrecio) {
        finPrecio.textContent = hay ? resumen + ' · ' + textoIva.split('.')[0] : '';
        finPrecio.hidden = !hay;
      }
      return p;
    }
    function actualizarTodo() {
      ZONAS.forEach(function (z) { items[z].forEach(pintarCotas); });
      pintarMedidaPanel();
      pintarPresupuesto();
      sincronizarPropiedades();
    }
    document.addEventListener('input', function (e) {
      if (e.target && e.target.name === 'quantity') pintarPresupuesto();
    });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'quantity') pintarPresupuesto();
    });

    function crearElemento(it) {
      var el = document.createElement('div');
      el.className = 'dfc-pv2-item';
      el.setAttribute('data-id', it.id);
      var img = new Image();
      img.alt = 'Tu diseño';
      img.draggable = false;
      img.src = it.url;
      el.appendChild(img);
      ['nw', 'ne', 'sw', 'se'].forEach(function (c) {
        var h = document.createElement('span');
        h.className = 'dfc-pv2-h dfc-pv2-h--' + c;
        h.setAttribute('data-c', c);
        el.appendChild(h);
      });
      ['h', 'v'].forEach(function (d) {
        var cota = document.createElement('span');
        cota.className = 'dfc-pv2-cota dfc-pv2-cota--' + d;
        cota.setAttribute('aria-hidden', 'true');
        cota.appendChild(document.createElement('b'));
        el.appendChild(cota);
      });
      el.addEventListener('pointerdown', alPulsarItem);
      it.el = el;
      posicionar(it);
      return el;
    }

    function buscarItem(id) {
      var lista = items[zonaActiva];
      for (var i = 0; i < lista.length; i++) if (lista[i].id === id) return lista[i];
      return null;
    }

    function pintarCapa() {
      capa.innerHTML = '';
      items[zonaActiva].forEach(function (it) {
        capa.appendChild(it.el || crearElemento(it));
        posicionar(it);
      });
    }

    function seleccionar(it) {
      sel = it;
      items[zonaActiva].forEach(function (o) {
        if (o.el) o.el.classList.toggle('is-selected', o === it);
      });
      actualizarPanel();
    }

    function actualizarPanel() {
      if (panelItem) panelItem.hidden = !sel;
      if (sel) {
        if (rango) rango.value = String(Math.round(sel.w));
        if (toggleFondo) toggleFondo.checked = !!sel.sinFondo;
        if (estadoFondo) estadoFondo.hidden = true;
      }
      pintarMedidaPanel();
      pintarPresupuesto();
      if (uploadTexto) {
        uploadTexto.textContent = items[zonaActiva].length ? textoOtra : textoSubida;
      }
      tabs.forEach(function (t) {
        var z = t.getAttribute('data-dfc-pv-tab');
        var n = items[z].length;
        var base = t.getAttribute('data-etiqueta') || t.textContent;
        if (!t.getAttribute('data-etiqueta')) t.setAttribute('data-etiqueta', base);
        t.textContent = n ? base + ' (' + n + ')' : base;
      });
      if (btnSiguiente) {
        var idx = ZONAS.indexOf(zonaActiva);
        btnSiguiente.textContent = idx < ZONAS.length - 1 ? textoContinuar + ' →' : textoFinalizar;
      }
    }

    /* ---------- Cambio de vista ---------- */
    function cambiarZona(z) {
      zonaActiva = z;
      sel = null;
      tabs.forEach(function (t) {
        var activo = t.getAttribute('data-dfc-pv-tab') === z;
        t.classList.toggle('dfc-pv-tab--activo', activo);
        t.setAttribute('aria-selected', activo ? 'true' : 'false');
      });
      aplicarBase(z);
      pintarGuia();
      pintarCapa();
      actualizarPanel();
      if (avisoVacio) avisoVacio.hidden = true;
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () { cambiarZona(t.getAttribute('data-dfc-pv-tab')); });
    });

    /* ---------- Técnica obligatoria ---------- */
    function bloquearSubida() {
      if (uploadLabel) uploadLabel.classList.toggle('dfc-pv-upload--bloqueado', !tecnica);
    }
    bloquearSubida();
    botonesTecnica.forEach(function (b) {
      b.addEventListener('click', function () {
        tecnica = b.getAttribute('data-dfc-pv-tecnica');
        botonesTecnica.forEach(function (o) {
          var act = o === b;
          o.classList.toggle('dfc-pv-tecnica--activa', act);
          o.setAttribute('aria-checked', act ? 'true' : 'false');
        });
        if (avisoTecnica) avisoTecnica.hidden = true;
        bloquearSubida();
        actualizarTodo();
        sincronizarPropiedades();
      });
    });
    if (uploadLabel) {
      uploadLabel.addEventListener('click', function (e) {
        if (!tecnica) {
          e.preventDefault();
          if (avisoTecnica) avisoTecnica.hidden = false;
        }
      });
    }

    /* ---------- Subir imágenes ---------- */
    fileInput.addEventListener('change', function () {
      var archivos = Array.prototype.slice.call(fileInput.files || []);
      fileInput.value = '';
      // En orden de selección: cada imagen espera a que cargue la anterior.
      archivos.reduce(function (cadena, file) {
        return cadena.then(function () { return anadirImagen(file); });
      }, Promise.resolve());
    });

    function anadirImagen(file) {
      return new Promise(function (resolve) {
        if (!file || !/^image\//.test(file.type)) { resolve(); return; }
        var url = URL.createObjectURL(file);
        var probe = new Image();
        probe.onload = function () {
          var aspecto = (probe.naturalWidth || 1) / (probe.naturalHeight || 1);
          var r = rectZona(zonaActiva);
          var lado = Math.min(r.w, r.h) * 0.9;
          var w = aspecto >= 1 ? lado : lado * aspecto;
          var it = {
            id: 'i' + (++contador),
            zona: zonaActiva,
            url: url,
            urlOriginal: url,
            file: file,
            fileOriginal: file,
            aspecto: aspecto,
            w: clamp(w, 6, 100),
            cx: r.x + r.w / 2,
            cy: r.y + r.h / 2,
            sinFondo: false,
            el: null
          };
          // Si ya hay imágenes, se desplaza un poco para que no se tapen del todo.
          var n = items[zonaActiva].length;
          if (n) {
            it.cx = clamp(it.cx + (n % 4) * 3, 0, 100);
            it.cy = clamp(it.cy + (n % 4) * 3, 0, 100);
          }
          items[zonaActiva].push(it);
          capa.appendChild(crearElemento(it));
          seleccionar(it);
          sincronizarPropiedades();
          resolve();
        };
        probe.onerror = function () { resolve(); };
        probe.src = url;
      });
    }

    /* ---------- Arrastrar y redimensionar ---------- */
    var arrastre = null;

    function alPulsarItem(e) {
      var el = e.currentTarget;
      var it = buscarItem(el.getAttribute('data-id'));
      if (!it) return;
      e.preventDefault();
      e.stopPropagation();
      seleccionar(it);
      var rect = stage.getBoundingClientRect();
      var asa = e.target && e.target.closest ? e.target.closest('.dfc-pv2-h') : null;
      try { el.setPointerCapture(e.pointerId); } catch (err) {}
      if (asa) {
        var c = asa.getAttribute('data-c');
        var wpx = (it.w / 100) * rect.width;
        var hpx = wpx / it.aspecto;
        var cxpx = (it.cx / 100) * rect.width;
        var cypx = (it.cy / 100) * rect.height;
        var sx = c.indexOf('e') !== -1 ? 1 : -1;
        var sy = c.indexOf('s') !== -1 ? 1 : -1;
        arrastre = {
          modo: 'redim', it: it, el: el, rect: rect, sx: sx, sy: sy,
          fx: cxpx - sx * wpx / 2,
          fy: cypx - sy * hpx / 2
        };
      } else {
        arrastre = {
          modo: 'mover', it: it, el: el, rect: rect,
          px: e.clientX, py: e.clientY, cx0: it.cx, cy0: it.cy
        };
      }
      el.addEventListener('pointermove', alMover);
      el.addEventListener('pointerup', alSoltar);
      el.addEventListener('pointercancel', alSoltar);
    }

    function alMover(e) {
      if (!arrastre) return;
      var a = arrastre;
      var it = a.it;
      var rect = a.rect;
      e.preventDefault();
      if (a.modo === 'mover') {
        it.cx = clamp(a.cx0 + ((e.clientX - a.px) / rect.width) * 100, 0, 100);
        it.cy = clamp(a.cy0 + ((e.clientY - a.py) / rect.height) * 100, 0, 100);
      } else {
        var mx = e.clientX - rect.left;
        var my = e.clientY - rect.top;
        var dx = (mx - a.fx) * a.sx;
        var dy = (my - a.fy) * a.sy;
        var nuevo = Math.max(dx, dy * it.aspecto);
        nuevo = clamp(nuevo, rect.width * 0.05, rect.width * 1.6);
        var esqx = a.fx + a.sx * nuevo;
        var esqy = a.fy + a.sy * (nuevo / it.aspecto);
        it.w = (nuevo / rect.width) * 100;
        it.cx = clamp(((a.fx + esqx) / 2 / rect.width) * 100, 0, 100);
        it.cy = clamp(((a.fy + esqy) / 2 / rect.height) * 100, 0, 100);
        if (rango) rango.value = String(Math.round(clamp(it.w, Number(rango.min), Number(rango.max))));
      }
      posicionar(it);
      if (a.modo !== 'mover') {
        pintarMedidaPanel();
        pintarPresupuesto();
      }
    }

    function alSoltar() {
      if (!arrastre) return;
      var el = arrastre.el;
      el.removeEventListener('pointermove', alMover);
      el.removeEventListener('pointerup', alSoltar);
      el.removeEventListener('pointercancel', alSoltar);
      arrastre = null;
      sincronizarPropiedades();
    }

    stage.addEventListener('pointerdown', function (e) {
      if (e.target && e.target.closest && e.target.closest('.dfc-pv2-item')) return;
      sel = null;
      items[zonaActiva].forEach(function (o) { if (o.el) o.el.classList.remove('is-selected'); });
      actualizarPanel();
    });

    if (rango) {
      rango.addEventListener('input', function () {
        if (!sel) return;
        var nuevo = Number(rango.value);
        sel.w = nuevo;
        posicionar(sel);
        pintarMedidaPanel();
        pintarPresupuesto();
      });
      rango.addEventListener('change', sincronizarPropiedades);
    }
    if (btnCentrar) {
      btnCentrar.addEventListener('click', function () {
        if (!sel) return;
        var r = rectZona(zonaActiva);
        sel.cx = r.x + r.w / 2;
        sel.cy = r.y + r.h / 2;
        posicionar(sel);
        sincronizarPropiedades();
      });
    }
    if (btnEliminar) {
      btnEliminar.addEventListener('click', function () {
        if (!sel) return;
        var lista = items[zonaActiva];
        var i = lista.indexOf(sel);
        if (i !== -1) lista.splice(i, 1);
        if (sel.el && sel.el.parentNode) sel.el.parentNode.removeChild(sel.el);
        sel = null;
        actualizarPanel();
        sincronizarPropiedades();
      });
    }
    document.addEventListener('keydown', function (e) {
      if (fin && !fin.hidden) {
        if (e.key === 'Escape') cerrarFinal(false);
        return;
      }
      if (!sel) return;
      var t = e.target;
      if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return;
      if (e.key === 'Delete' || e.key === 'Backspace') {
        e.preventDefault();
        if (btnEliminar) btnEliminar.click();
      }
    });

    /* ---------- Quitar fondo de la imagen seleccionada ---------- */
    if (toggleFondo) {
      toggleFondo.addEventListener('change', function () {
        var it = sel;
        if (!it) return;
        var img = it.el && it.el.querySelector('img');
        if (!toggleFondo.checked) {
          it.sinFondo = false;
          it.url = it.urlOriginal;
          it.file = it.fileOriginal;
          if (img) img.src = it.url;
          if (estadoFondo) estadoFondo.hidden = true;
          sincronizarPropiedades();
          return;
        }
        if (estadoFondo) {
          estadoFondo.hidden = false;
          estadoFondo.textContent = 'Quitando el fondo… la primera vez puede tardar unos segundos.';
        }
        quitarFondo(it.urlOriginal, function (blob) {
          if (!blob) {
            toggleFondo.checked = false;
            if (estadoFondo) estadoFondo.textContent = 'No se ha podido quitar el fondo de esta imagen. Se muestra la original.';
            return;
          }
          it.sinFondo = true;
          it.url = URL.createObjectURL(blob);
          it.file = new File([blob], 'diseno-sin-fondo.png', { type: blob.type || 'image/png' });
          if (img) img.src = it.url;
          if (estadoFondo) estadoFondo.textContent = 'Fondo eliminado. Si no ha quedado bien, desmarca la casilla.';
          sincronizarPropiedades();
        });
      });
    }

    /* ---------- Propiedades del pedido ---------- */
    function buscarFormulario() {
      return document.querySelector('form[action*="/cart/add"]');
    }
    function sincronizarPropiedades() {
      var form = buscarFormulario();
      if (!form) return;
      var previos = form.querySelectorAll('[data-dfc-pv-propiedad]');
      Array.prototype.forEach.call(previos, function (n) { n.parentNode.removeChild(n); });

      function oculto(nombre, valor) {
        var i = document.createElement('input');
        i.type = 'hidden';
        i.name = 'properties[' + nombre + ']';
        i.value = valor;
        i.setAttribute('data-dfc-pv-propiedad', '');
        form.appendChild(i);
      }

      var resumen = [];
      ZONAS.forEach(function (z) {
        var lista = items[z];
        if (!lista.length) return;
        resumen.push(ETIQUETAS[z] + ' ' + lista.length);
        lista.forEach(function (it, idx) {
          var etiqueta = ETIQUETAS[z] + ' ' + (idx + 1);
          if (it.file) {
            var f = document.createElement('input');
            f.type = 'file';
            f.name = 'properties[Diseño – ' + etiqueta + ']';
            f.style.display = 'none';
            f.setAttribute('data-dfc-pv-propiedad', '');
            try {
              var dt = new DataTransfer();
              dt.items.add(it.file);
              f.files = dt.files;
            } catch (err) {}
            form.appendChild(f);
          }
          var m = medidaCm(it);
          var tramos = tramosPorTecnica[tecnica] || [];
          var t = m && tramos.length ? tramoPara(m.w, m.h, tramos) : null;
          oculto('Ajuste – ' + etiqueta,
            (m ? cm(m.w) + ' × ' + cm(m.h) + ' cm' + (t ? ' (tramo ' + t.nombre + ')' : ' (a consultar)') + ', ' : '') +
            'tamaño ' + Math.round(it.w) + '% del ancho, centro X ' + Math.round(it.cx) + '%, Y ' + Math.round(it.cy) + '%');
        });
      });
      if (tecnica) oculto('Técnica', TECNICAS[tecnica] || tecnica);
      if (resumen.length) oculto('Resumen del diseño', resumen.join(', '));
      if (tecnica && resumen.length) {
        var p = calcularPresupuesto();
        if (p.sinTarifa) {
          oculto('Estampación estimada', 'A consultar');
        } else {
          oculto('Estampación estimada', euros(p.total) + ' sin IVA' + (p.aConsultar ? ' + parte a consultar' : ''));
          if (precioPrenda !== null) oculto('Total estimado por prenda', euros(Math.round((precioPrenda + p.total) * 100) / 100) + ' sin IVA');
        }
      }
    }

    /* ---------- Continuar / finalizar ---------- */
    function totalImagenes() {
      return ZONAS.reduce(function (n, z) { return n + items[z].length; }, 0);
    }
    if (btnSiguiente) {
      btnSiguiente.addEventListener('click', function () {
        var idx = ZONAS.indexOf(zonaActiva);
        if (idx < ZONAS.length - 1) {
          cambiarZona(ZONAS[idx + 1]);
          return;
        }
        abrirFinal();
      });
    }
    var btnVerTodo = root.querySelector('[data-pv2-ver]');
    if (btnVerTodo) btnVerTodo.addEventListener('click', abrirFinal);

    /* ---------- Vista final: la prenda gira ---------- */
    var finBase = fin && fin.querySelector('[data-pv2-fin-base]');
    var finCapa = fin && fin.querySelector('[data-pv2-fin-capa]');
    var finTarjeta = fin && fin.querySelector('[data-pv2-fin-tarjeta]');
    var finEtiqueta = fin && fin.querySelector('[data-pv2-fin-etiqueta]');
    var finPuntos = fin ? fin.querySelectorAll('[data-pv2-fin-punto]') : [];
    var finPlay = fin && fin.querySelector('[data-pv2-fin-play]');
    var giroIdx = 0;
    var girando = false;
    var timerGiro = null;
    var reproduciendo = false;
    var sinMovimiento = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function pintarVistaFinal(z) {
      var v = vistas[z] || vistas.delantera;
      finBase.src = v.src;
      finBase.classList.toggle('dfc-pv2-espejo', !!v.espejo);
      finCapa.innerHTML = '';
      items[z].forEach(function (it) {
        var c = document.createElement('div');
        c.className = 'dfc-pv2-item dfc-pv2-item--fijo';
        c.style.width = it.w + '%';
        c.style.left = it.cx + '%';
        c.style.top = it.cy + '%';
        c.style.aspectRatio = String(it.aspecto);
        var im = new Image();
        im.src = it.url;
        im.alt = '';
        c.appendChild(im);
        finCapa.appendChild(c);
      });
      var n = items[z].length;
      if (finEtiqueta) finEtiqueta.textContent = ETIQUETAS[z] + (n ? ' · ' + n + (n === 1 ? ' imagen' : ' imágenes') : ' · sin diseño');
      Array.prototype.forEach.call(finPuntos, function (p, i) {
        p.classList.toggle('is-activo', i === giroIdx);
      });
    }

    function girarA(idx) {
      idx = (idx + ORDEN_GIRO.length) % ORDEN_GIRO.length;
      if (girando || idx === giroIdx) return;
      if (sinMovimiento) {
        giroIdx = idx;
        pintarVistaFinal(ORDEN_GIRO[idx]);
        return;
      }
      girando = true;
      finTarjeta.classList.remove('dfc-pv2-entrada');
      finTarjeta.classList.add('dfc-pv2-salida');
      setTimeout(function () {
        giroIdx = idx;
        pintarVistaFinal(ORDEN_GIRO[idx]);
        finTarjeta.classList.remove('dfc-pv2-salida');
        finTarjeta.classList.add('dfc-pv2-entrada');
        setTimeout(function () {
          finTarjeta.classList.remove('dfc-pv2-entrada');
          girando = false;
        }, 280);
      }, 280);
    }

    function iniciarGiro() {
      detenerGiro();
      reproduciendo = true;
      if (finPlay) finPlay.textContent = 'Pausar';
      timerGiro = setInterval(function () { girarA(giroIdx + 1); }, 2600);
    }
    function detenerGiro() {
      reproduciendo = false;
      if (timerGiro) { clearInterval(timerGiro); timerGiro = null; }
      if (finPlay) finPlay.textContent = 'Girar';
    }

    function abrirFinal() {
      if (!fin) return;
      if (!totalImagenes()) {
        if (avisoVacio) avisoVacio.hidden = false;
        return;
      }
      if (avisoVacio) avisoVacio.hidden = true;
      sincronizarPropiedades();
      fin.hidden = false;
      document.documentElement.classList.add('dfc-pv2-bloqueado');
      giroIdx = 0;
      girando = false;
      pintarVistaFinal(ORDEN_GIRO[0]);
      if (autoGiro && !sinMovimiento) iniciarGiro(); else detenerGiro();
    }
    function cerrarFinal(irAlPedido) {
      if (!fin) return;
      detenerGiro();
      fin.hidden = true;
      document.documentElement.classList.remove('dfc-pv2-bloqueado');
      if (irAlPedido) {
        var form = buscarFormulario();
        if (form && form.scrollIntoView) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    if (fin) {
      var cerrar = fin.querySelector('[data-pv2-fin-editar]');
      var listo = fin.querySelector('[data-pv2-fin-listo]');
      if (cerrar) cerrar.addEventListener('click', function () { cerrarFinal(false); });
      if (listo) listo.addEventListener('click', function () { cerrarFinal(true); });
      if (finPlay) {
        finPlay.addEventListener('click', function () {
          if (reproduciendo) detenerGiro(); else iniciarGiro();
        });
      }
      Array.prototype.forEach.call(finPuntos, function (p, i) {
        p.addEventListener('click', function () { detenerGiro(); girarA(i); });
      });
      // Girar arrastrando a izquierda/derecha
      var gx = null;
      finTarjeta.addEventListener('pointerdown', function (e) { gx = e.clientX; });
      finTarjeta.addEventListener('pointermove', function (e) {
        if (gx === null) return;
        var d = e.clientX - gx;
        if (Math.abs(d) > 50) {
          detenerGiro();
          girarA(giroIdx + (d < 0 ? 1 : -1));
          gx = e.clientX;
        }
      });
      var soltar = function () { gx = null; };
      finTarjeta.addEventListener('pointerup', soltar);
      finTarjeta.addEventListener('pointercancel', soltar);
      finTarjeta.addEventListener('pointerleave', soltar);
    }

    // Estado inicial
    pintarGuia();
    actualizarPanel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
